import script from "./CurrentLiabilities.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentLiabilities.vue?vue&type=script&setup=true&lang=js"

import "./CurrentLiabilities.vue?vue&type=style&index=0&id=250e8934&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250e8934"]])

export default __exports__